import Segment from './tracking';
import GTM from './gtm';

export default Segment;
export { GTM };
